import ALink from 'tradera/components/alink/alink';

import { useUrlLocalizer } from 'tradera/lang/translate';
import { TraderaLogo } from 'tradera/components/tradera-logo/tradera-logo';

export const FormFooterLogo = () => {
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <ALink aria-label="Home" href={toLocalizedUrl('/')}>
            <TraderaLogo />
        </ALink>
    );
};
